import React, { useState } from 'react';
import { Trash2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReviewsTab = ({ reviews, onRefresh }) => {
  const [newReview, setNewReview] = useState({ name: '', text: '' });

  const handleAddReview = async (e) => {
    e.preventDefault();
    if (!newReview.name.trim() || !newReview.text.trim()) return;
    try {
      await axios.post(`${API}/reviews`, { name: newReview.name.trim(), text: newReview.text.trim() });
      toast.success('Review added');
      setNewReview({ name: '', text: '' });
      onRefresh();
    } catch (error) { toast.error(error.response?.data?.detail || 'Failed to add review'); }
  };

  const handleDeleteReview = async (reviewId) => {
    if (!window.confirm('Are you sure you want to delete this review?')) return;
    try {
      await axios.delete(`${API}/reviews/${reviewId}`);
      toast.success('Review deleted');
      onRefresh();
    } catch { toast.error('Failed to delete review'); }
  };

  return (
    <div>
      <h2 className="text-2xl font-normal mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Manage Reviews</h2>
      <p className="text-sm text-gray-400 mb-8">Add or remove client reviews shown on the home page.</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div className="border border-white/10 p-8">
          <h3 className="text-lg font-normal mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>Add Review</h3>
          <form onSubmit={handleAddReview} className="space-y-4" data-testid="add-review-form">
            <input type="text" value={newReview.name} onChange={(e) => setNewReview({ ...newReview, name: e.target.value })} placeholder="Reviewer name" className="w-full bg-black border border-white/10 rounded-none px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-white/30 transition-colors" required data-testid="review-name-input" />
            <textarea value={newReview.text} onChange={(e) => setNewReview({ ...newReview, text: e.target.value })} placeholder="Review text" rows={4} className="w-full bg-black border border-white/10 rounded-none px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-white/30 transition-colors resize-none" required data-testid="review-text-input" />
            <button type="submit" className="w-full bg-white text-black hover:bg-gray-200 rounded-none px-8 py-4 text-sm uppercase tracking-widest transition-all duration-300" data-testid="add-review-btn">Add Review</button>
          </form>
        </div>
        <div className="border border-white/10 p-8">
          <h3 className="text-lg font-normal mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>Current Reviews ({reviews.length})</h3>
          {reviews.length === 0 ? (
            <p className="text-gray-400 text-sm">No reviews yet.</p>
          ) : (
            <div className="space-y-4">
              {reviews.map((review) => (
                <div key={review.id} className="border border-white/10 p-4" data-testid={`review-item-${review.id}`}>
                  <div className="flex items-start justify-between gap-4">
                    <div className="min-w-0">
                      <p className="text-sm text-gray-300 italic mb-2">"{review.text}"</p>
                      <p className="text-xs text-white tracking-wide">— {review.name}</p>
                    </div>
                    <button onClick={() => handleDeleteReview(review.id)} className="text-gray-500 hover:text-red-400 transition-colors shrink-0 p-1" data-testid={`delete-review-${review.id}`}><Trash2 size={16} /></button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewsTab;
